import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=04ef6adc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=04ef6adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef6adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ef6adc')) {
      api.createRecord('04ef6adc', component.options)
    } else {
      api.reload('04ef6adc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=04ef6adc&scoped=true&", function () {
      api.rerender('04ef6adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2259AD7csNT6b/JS/comp/PopupBox.vue"
export default component.exports